import axios from '@/utils/axios';

export const leadImportConfig = async () => {
 const response = await axios.get(`/lead-import-configs`);
 return response;
};

export const leadImportConfigByPlatform = async (platform) => {
 const response = await axios.get(`/lead-import-configs/platform/${platform}`);
 return response;    
}

export const countries = async () => {
 const response = await axios.get('/countries');
 return response;   
}

export const states = async (country_id) => {
 const response = await axios.get(`/states/${country_id}`);
 return response;   
}

export const pincodeWiseAddress = async (pincode) => {
 const response = await axios.get(`/pincode-wise-address/${pincode}`);
 return response;   
}